import gql from "graphql-tag";

// Campos de un QR. Es texto y no un documento porque se interpola dentro de los demás.
const CAMPOS_QR = `id folderId archived archivedAt name type destination phone message status version publicUrl code createdAt updatedAt`;

// Lo que devuelven las mutaciones y el detalle: con el diseño, pero sin el logo, que va en
// base64 y pesa hasta 350.000 caracteres.
export const QR_FIELDS = `${CAMPOS_QR} design { color pattern }`;

// El QR completo. Solo lo pide QR_GET, porque el editor necesita el logo para mostrarlo y
// volver a enviarlo: sin él, guardar dejaría el QR sin logo.
export const QR_FIELDS_CON_LOGO = `${CAMPOS_QR} design { color pattern logo }`;

// Lo que necesitan la lista de códigos y el selector del dashboard: sin el diseño, porque el logo va en
// base64 y pesa. Para editar o duplicar se pide el QR completo con QR_GET.
export const QR_LIST_FIELDS = `id folderId archived archivedAt name type destination status version updatedAt`;

// Cuántos códigos QR incluye el plan de la empresa (plan más adicionales). Es la consulta del
// Inicio, que ya trae los límites del plan en usuarios_plan; acá se pide solo cantidad_qr. La
// usa store/modules/qr/Cupo.js, que tolera que el backend todavía no tenga el campo.
export const QR_CUPO_PLAN = gql`
  query DashboardEmpresaYear($fecha: String!) {
    DashboardEmpresaYear(fecha: $fecha) {
      usuarios_plan {
        cantidad_qr
      }
    }
  }
`;

// Cada documento se llama igual que su campo raíz: exQue y exMut leen el resultado con ese nombre.
export const QR_LIST = gql`
  query qrAdminList($search: String, $offset: Int, $limit: Int, $folderId: String, $archive: String) {
    qrAdminList(search: $search, offset: $offset, limit: $limit, folderId: $folderId, archive: $archive) {
      total
      items {
        ${QR_LIST_FIELDS}
      }
    }
  }
`;

export const QR_STATS = gql`
  query qrAdminStatistics($id: ID!, $from: String, $to: String) {
    qrAdminStatistics(id: $id, from: $from, to: $to) {
      total
      excludedBots
      lastScan
      from
      to
      daily {
        date
        count
      }
      devices {
        name
        count
      }
    }
  }
`;

export const QR_GET = gql`
  query qrAdminGet($id: ID!) {
    qrAdminGet(id: $id) {
      ${QR_FIELDS_CON_LOGO}
    }
  }
`;

export const QR_FOLDERS = gql`
  query qrAdminFolders {
    qrAdminFolders {
      id
      name
      version
      count
      updatedAt
    }
  }
`;

export const QR_OVERVIEW = gql`
  query qrAdminOverview(
    $from: String
    $to: String
    $folderId: String
    $archive: String
    $qrId: ID
    $allTime: Boolean
  ) {
    qrAdminOverview(
      from: $from
      to: $to
      folderId: $folderId
      archive: $archive
      qrId: $qrId
      allTime: $allTime
    ) {
      allTime
      total
      excludedBots
      lastScan
      from
      to
      folderId
      archive
      qrId
      daily {
        date
        count
      }
      devices {
        name
        count
      }
      counts {
        total
        active
        draft
        paused
        archived
      }
      ranking {
        id
        name
        status
        archived
        count
      }
    }
  }
`;
